import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { VolunteerService } from 'src/app/core/services/volunteer.service';

@Component({
  selector: 'app-volunteer-category',
  templateUrl: './volunteer-category.component.html',
  styleUrls: ['./volunteer-category.component.scss']
})
export class VolunteerCategoryComponent implements OnInit {
  volunteerCategories = [];

  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private volunteerService: VolunteerService) { }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    this.getVolunteerCategories();
  }

  getVolunteerCategories(){
    this.volunteerService.getVolunteerCategories().subscribe(response => {
      if (response.success) {
        console.log(response);
        this.volunteerCategories = response.volunteerCategories;
      }
      else {
        this.alertService.alert('Hata!', 'Kategoriler alınamadı.', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  deleteVolunteerCategory(id: string, name: string) {
    const x = confirm(name + ' isimli gönüllü kategorisini silmek istediğinize emin misiniz?');
    if (x) {
      this.volunteerService.deleteVolunteerCategory(id).subscribe(response => {
        if (response.success) {
          this.getVolunteerCategories();
          this.alertService.alert("Başarılı!", "Gönüllü kategorisi silindi!", "success");
        } else {
          this.alertService.alert("Hata!", "Gönüllü kategorisi silinemedi!", "error");
        }
      })
    }
  }

}
